(function () {
  var refreshTimer;

  function cartEndpoint() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js';
  }

  function ensureBubble(cartIcon) {
    var bubble = cartIcon.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true" data-navura-cart-count></span><span class="visually-hidden" data-navura-cart-label></span>';
      cartIcon.appendChild(bubble);
    }

    var number = bubble.querySelector('[data-navura-cart-count]') || bubble.querySelector('span[aria-hidden="true"]');
    if (!number) {
      number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.setAttribute('data-navura-cart-count', '');
      bubble.insertBefore(number, bubble.firstChild);
    } else {
      number.setAttribute('data-navura-cart-count', '');
    }

    var label = bubble.querySelector('[data-navura-cart-label]') || bubble.querySelector('.visually-hidden');
    if (!label) {
      label = document.createElement('span');
      label.className = 'visually-hidden';
      label.setAttribute('data-navura-cart-label', '');
      bubble.appendChild(label);
    } else {
      label.setAttribute('data-navura-cart-label', '');
    }

    return { bubble: bubble, number: number, label: label };
  }

  function renderCartCount(count) {
    var itemCount = Number(count) || 0;

    document.querySelectorAll('.js-cart-icon-bubble').forEach(function (cartIcon) {
      var bubble = cartIcon.querySelector('.cart-count-bubble');

      if (itemCount < 1) {
        if (bubble) {
          bubble.hidden = true;
          bubble.dataset.empty = 'true';
          bubble.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      var parts = ensureBubble(cartIcon);
      parts.number.textContent = itemCount > 99 ? '99+' : String(itemCount);
      parts.label.textContent = itemCount + (itemCount === 1 ? ' item in cart' : ' items in cart');
      parts.bubble.hidden = false;
      parts.bubble.dataset.empty = 'false';
      parts.bubble.removeAttribute('aria-hidden');
    });
  }

  function refreshCartCount() {
    return fetch(cartEndpoint(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartCount, delay || 250);
  }

  window.updateNavuraCartCount = refreshCartCount;
  window.renderNavuraCartCount = renderCartCount;

  document.addEventListener('DOMContentLoaded', function () {
    refreshCartCount();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count !== 'undefined') {
          renderCartCount(event.cartData.item_count);
        }
        scheduleRefresh(80);
      });
    }

    ['cart:updated', 'cart:update', 'cart:refresh'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleRefresh(80);
      });
    });

    document.addEventListener('submit', function (event) {
      if (event.target && event.target.matches('form[action*="/cart/add"]')) {
        scheduleRefresh(900);
        window.setTimeout(refreshCartCount, 1800);
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('[name="add"], [data-add-to-cart]') : null;
      if (target) {
        scheduleRefresh(900);
        window.setTimeout(refreshCartCount, 1800);
      }
    });

    window.addEventListener('pageshow', function () {
      scheduleRefresh(80);
    });
  });
})();